import logo from "../../assets/logo.png";
import Loader from "../Loader/Loader";

import styles from "./Auth.module.css";
import CodeInput from "./CodeInput/CodeInput";

function Auth({ authenticate, setAuthCode, isLoading, error, errorText }) {
	const handleCode = (code) => {
		if (code.length === 6) {
            setAuthCode(code);
		}
	};

	return (
		<div className={styles.container}>
			<div className={styles.blur}>
				<div className={styles.card}>
					<img
						src={logo}
						className={styles.logo}
						alt="Link"
					/>
					<div className={styles.content}>
						<div className={styles.title}>
							Autenticação necessária
						</div>
						<div className={styles.body}>
							Para acessar o boletim acadêmico é necessário
							digitar os{" "}
							<span className={styles.bold}>
								6 primeiros digitos do seu CPF
							</span>
						</div>
					</div>
					<CodeInput onChange={handleCode} />
					{error && <div className={styles.error}>{errorText}</div>}
					<button
						className={styles.button}
						onClick={authenticate}
                        disabled={isLoading}
					>
						{isLoading ? <Loader /> : "Acessar Boletim"}
					</button>
				</div>
			</div>
		</div>
	);
}

export default Auth;
